import { graphql } from '~/lib/graphql'

export const ReserveInfoPlan = graphql(`
  fragment ReserveInfoPlan on ReserveInfo {
    plan {
      planId
      version
      additionalContents
      restrictions
      paymentType
      notes
      isRequestReservation
      description
      isSeatOnly
      isCancelGuard
      price
      ...PlanRestaurant
      ...PlanCancelPolicy
      timesale {
        visibleLabel
      }
      course {
        name
        menuText
        images {
          url
          name
        }
      }
    }
  }
`)
